<template>
  <div class="user_body">
    <span class="title">个人信息</span>
    <div class="user_item">
      <span class="form-label">头像：</span>
      <img class="user_icon" :src="userForm.avatar || require('@/assets/user_icon1.png')" @click="uploadAvatar">
    </div>
    <div class="user_item">
      <span class="form-label">密码：</span>
      <span class="text2" style="cursor: pointer;" v-if="!showPasswordInput" @click="showPasswordInput = true">点击修改</span>
      <el-input v-model="userForm.password" placeholder="留空是默认不修改密码" class="input_size" size="small" type="password" v-if="showPasswordInput"></el-input>
      <span class="cancel_btn" style="cursor: pointer;" v-if="showPasswordInput" @click="handleCancelPassword">取消修改</span>
    </div>
    <div class="user_item">
      <span class="form-label">昵称：</span>
      <el-input v-model="userForm.nickname" placeholder="请输入昵称" class="input_size" size="small"></el-input>
    </div>
    <div class="user_item">
      <span class="form-label">姓名：</span>
      <el-input v-model="userForm.realname" placeholder="请输入姓名" class="input_size" size="small"></el-input>
    </div>
    <div class="user_item">
      <span class="form-label">身份：</span>
      <el-select
        v-model="selectedIdentity"
        placeholder="请选择身份"
        class="input_size"
        size="small"
        @change="handleIdentityChange"
      >
        <el-option
          v-for="item in identityConfig"
          :key="item.label"
          :label="item.label"
          :value="item.label"
        ></el-option>
      </el-select>
    </div>
    <div class="user_item" v-if="currentIdentityConfig && currentIdentityConfig.secondaryLabel">
      <span class="form-label">{{ currentIdentityConfig.secondaryLabel }}：</span>
      <el-select
        v-if="currentIdentityConfig.type === 'select'"
        v-model="secondaryIdentity"
        placeholder="请选择"
        class="input_size"
        size="small"
        @change="handleSecondaryIdentityChange"
      >
        <el-option
          v-for="option in currentIdentityConfig.options"
          :key="option"
          :label="option"
          :value="option"
        ></el-option>
      </el-select>
      <el-input
        v-else
        v-model="secondaryIdentity"
        :placeholder="`请输入${currentIdentityConfig.secondaryLabel}`"
        class="input_size"
        size="small"
       
      ></el-input>
    </div>
    <div class="user_item">
      <span class="form-label">工作单位：</span>
   
      <el-input v-model="userForm.workunit" placeholder="请输入工作单位" class="input_size" size="small"></el-input>
    </div>
    <div class="user_item">
      <span class="form-label">研究方向：</span>
      <el-input v-model="userForm.research_direction" placeholder="请输入研究方向" class="input_size" size="small"></el-input>
    </div>
    <div class="user_item">
      <span class="form-label">课题组：</span>
      <el-input v-model="userForm.research_group" placeholder="请输入课题组" class="input_size" size="small"></el-input>
    </div>
    <div class="user_item">
      <span class="form-label">会员等级：</span>
      <span class="text2">{{ userInfo.level_name || '普通会员' }}</span>
    </div>
    <!-- <div class="user_item">
      <span>会员天数：</span>
      <span class="text1">{{ userInfo.member_days || '0' }}天</span>
    </div> -->
    <div class="user_item">
      <span class="form-label">手机号码：</span>

      <span class="text2" style="cursor: pointer;" v-if="!showMobileInput" @click="showMobileInput = true">{{ userInfo.mobile ? userInfo.mobile : '未绑定' }}</span>
      <el-input v-if="showMobileInput" v-model="userForm.mobile" placeholder="请输入手机号码" class="input_size" size="small"></el-input>
    </div> 
    <div class="user_item">
      <span class="form-label">邮箱地址：</span>
       <span class="text2" style="cursor: pointer;" v-if="!showEmailInput" @click="showEmailInput = true">{{ userInfo.email ? userInfo.email : '未绑定' }}</span>
       <el-input v-if="showEmailInput" v-model="userForm.email" placeholder="请输入邮箱地址" class="input_size" size="small"></el-input>
    </div>
    <div class="user_item">
      <span class="form-label"></span>
      <span class="btns" @click="saveUserInfo">保存资料</span>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';
export default {
  name: "UserInfoView",
  data() {
    return {
      userInfo: {},
      userForm: {
        password: '',
        nickname: '',
        realname: '',
        shenfen: '',
        workunit: '',
        email: '',
        mobile: '',
        avatar: '',
        research_direction: '',
        research_group: ''
      },
      workOptions: [],
      showEmailInput: false,
      showMobileInput: false,
      selectedIdentity: '',
      secondaryIdentity: '',
      identityInitializing: false,
      identityConfig: [
        {
          label: '学生',
          type: 'select',
          secondaryLabel: '学习阶段',
          options: ['本科在读', '硕士在读', '博士在读']
        },
        {
          label: '研究员/老师',
          type: 'select',
          secondaryLabel: '岗位',
          options: ['教学/科研', '平台管理']
        },
        {
          label: '医生',
          type: 'input',
          secondaryLabel: '所属科室'
        },
        {
          label: '企业/科研单位职员',
          type: 'select',
          secondaryLabel: '岗位',
          options: ['生产/研发', '采购负责人', '管理']
        },
        {
          label: '代理商',
          type: 'input',
          secondaryLabel: false
        },
        {
          label: '其他',
          type: 'input',
          secondaryLabel: '身份信息'
        }
      ],
      showPasswordInput: false
    };
  },
  mounted() {
    this.getUserInfo();
  },
  computed: {
    ...mapGetters(['user','base']),
    currentIdentityConfig() {
      return this.identityConfig.find(item => item.label === this.selectedIdentity) || null;
    }
  },
  watch: {
    base: {
      handler(newVal) {
        if(newVal.workunit){
          this.workOptions = newVal.workunit.map(item => ({
            value: item,
            label: item
          }));
        }
      },
    },
    // selectedIdentity(newVal) {
    //   if (this.identityInitializing) return;
    //   if (!newVal) {
    //     this.secondaryIdentity = '';
    //     this.userForm.shenfen = '';
    //     return;
    //   }
    //   this.secondaryIdentity = '';
    //   this.updateIdentityValue();
    // },
    secondaryIdentity() {
      if (this.identityInitializing) return;
      this.updateIdentityValue();
    }
  },
  methods: {
    ...mapActions(['getUserInfo']),
    handleCancelPassword(){
      this.showPasswordInput = false;
      this.userForm.password = '';
    },
    // 获取用户信息
    async getUserInfo() {
      try {
        const res = await this.$api.getUserInfo();
        if (res.code === 1) {
          this.userInfo = res.data;
          
          // 填充表单
          this.userForm = {
            password: '',  // 密码默认为空
            nickname: this.userInfo.nickname || '',
            realname: this.userInfo.realname || '',
            shenfen: this.userInfo.shenfen || '',
            workunit: this.userInfo.workunit || '',
            mobile: this.userInfo.mobile || '',
            email: this.userInfo.email || '',
            avatar: this.userInfo.avatar || '',
            research_direction: this.userInfo.research_direction || '',
            research_group: this.userInfo.research_group || ''
          };
          this.initIdentitySelection(this.userForm.shenfen);
        } else {
          this.$message.error(res.message || '获取用户信息失败');
        }
      } catch (err) {
        this.$message.error(err.message || '获取用户信息失败');
      }
    },
    
    // 保存用户信息
    async saveUserInfo() {
      try {
        const data = {
          ...this.userForm,
          type: 22  
        };
        
        // 如果密码为空，则不提交密码字段
        if (!data.password) {
          delete data.password;
        }
        
        const res = await this.$api.updateUserInfo(data);
        if (res.code === 1) {
          this.$message.success('保存成功');
          // 刷新用户信息
          this.getUserInfo();
        } else {
          this.$message.error(res.message || '保存失败');
        }
      } catch (err) {
        this.$message.error(err.message || '保存失败');
      }
    },
    // 上传头像
    uploadAvatar() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.click();
      input.onchange = () => {
        this.$api.upload({
          file: input.files[0]
        }).then(res => {
          if(res.code === 1){
            this.userForm.avatar = res.data.fullurl;
          }
        }).catch(err => {
          console.log(err);
        });
      };
    },
    handleSecondaryIdentityChange(value) {
      console.log('handleSecondaryIdentityChange',value);
      // this.userForm.shenfen = this.selectedIdentity + '-' + value;
      this.updateIdentityValue();
    },
    handleIdentityChange(value) {
      console.log('handleIdentityChange',value);
      if (!value) {
        this.secondaryIdentity = '';
        this.userForm.shenfen = '';
        return;
      }
      this.secondaryIdentity = '';
      this.updateIdentityValue();
    },
    initIdentitySelection(savedValue) {
      this.identityInitializing = true;
      if (!savedValue) {
        this.selectedIdentity = '';
        this.secondaryIdentity = '';
        this.identityInitializing = false;
        return;
      }
      const [primary, ...rest] = savedValue.split('-');
      const reconstructedSecondary = rest.join('-');
      const matchedByLabel = this.identityConfig.find(config => config.label === primary);
     
      if (matchedByLabel) {
        this.selectedIdentity = matchedByLabel.label;
        this.secondaryIdentity = reconstructedSecondary || '';
        
        this.updateIdentityValue();
        console.log('matchedByLabel',this.secondaryIdentity,this.currentIdentityConfig);
        this.$nextTick(() => {
          this.$forceUpdate();
        });
        // this.identityInitializing = false;
        return;
      }
      const matchedByOption = this.identityConfig.find(config => {
        if (config.type === 'select') {
          return config.options.includes(savedValue);
        }
        return false;
      });
      if (matchedByOption) {
        this.selectedIdentity = matchedByOption.label;
        this.secondaryIdentity = savedValue;
        this.identityInitializing = false;
        this.updateIdentityValue();
        return;
      }
      this.selectedIdentity = '其他';
      this.secondaryIdentity = reconstructedSecondary || primary;
      this.identityInitializing = false;
      this.updateIdentityValue();
    },
    updateIdentityValue() {
      if (!this.selectedIdentity) {
        this.userForm.shenfen = '';
        return;
      }
      if (!this.currentIdentityConfig) {
        this.userForm.shenfen = this.selectedIdentity;
        return;
      }
      if (this.currentIdentityConfig.type === 'select' || this.currentIdentityConfig.type === 'input') {
        this.userForm.shenfen = this.secondaryIdentity
          ? `${this.selectedIdentity}-${this.secondaryIdentity}`
          : this.selectedIdentity;
        return;
      }
      this.userForm.shenfen = this.selectedIdentity;
    }
  }
};
</script>

<style lang="less" scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
}
.title {
  color: #666666;
  font-size: 16px;
}
.user_item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;

  .form-label{
    width: 100px;
    font-size: 14px;
    color: #333333;
    text-align: right;
  }
 
}

.user_item span:nth-child(odd) {
  width: 100px;
  font-size: 14px;
  color: #333333;
  text-align: right;
}
.cancel_btn{
    color: #3c9c8f !important;
    font-size: 14px;
    cursor: pointer;
    margin-left: 10px;
    width: fit-content !important;
  }
.text1 {
  font-size: 14px;
  color: #333333;
}
.text2 {
  font-size: 14px;
  color: #3c9c8f;
}
.user_icon {
  cursor: pointer;
  width: 70px;
  height: 70px;
  border-radius: 70px;
  object-fit: cover;
}
.input_size {
  width: 300px;
}
.btns{
    width: 160px;
    height: 40px;
    color: #ffffff;
    background: #3C9C8F;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    margin-top: 20px;
    cursor: pointer;
    border-radius: 4px;
}
.btns:hover {
    background: #34897e;
}

:deep(.el-select){
  display: inline-block;
    position: relative;
  width: 300px !important;
}
</style>

<style>

</style>

